export const SoundData = [
  {
    keyChar: "a",
    soundFile: "/sounds/boom.wav",
    soundDesc: "808",
    shadowId: "shadow-red-600",
    id: 1,
  },
  {
    keyChar: "s",
    soundFile: "/sounds/kick.wav",
    soundDesc: "kick",
    shadowId: "shadow-blue-600",
    id: 2,
  },
  {
    keyChar: "d",
    soundFile: "/sounds/hihat.wav",
    soundDesc: "hi-hat",
    shadowId: "shadow-green-600",
    id: 3,
  },
  {
    keyChar: "f",
    soundFile: "/sounds/yeaho.wav",
    soundDesc: "🔥",
    shadowId: "shadow-orange-600",
    id: 4,
  },
  {
    keyChar: "g",
    soundFile: "/sounds/openhat.wav",
    soundDesc: "open-hat",
    shadowId: "shadow-emerald-600",
    id: 5,
  },
  {
    keyChar: "h",
    soundFile: "/sounds/clap.wav",
    soundDesc: "clap",
    shadowId: "shadow-yellow-600",
    id: 6,
  },
  {
    keyChar: "j",
    soundFile: "/sounds/snare.wav",
    soundDesc: "snare",
    shadowId: "shadow-blue-600",
    id: 7,
  },
  {
    keyChar: "k",
    soundFile: "/sounds/tink.wav",
    soundDesc: "tink",
    shadowId: "shadow-yellow-600",
    id: 8,
  },
  {
    keyChar: "l",
    soundFile: "/sounds/tom.wav",
    soundDesc: "tom",
    shadowId: "shadow-red-600",
    id: 9,
  },
];
